module.exports = __webpack_public_path__ + "static/img/cont43_05.a3c416c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_05.jpg
// module id = zDZY
// module chunks = 0